import React from 'react';

import { imageFormatStringCodec } from '@deckee/utilities';
import {
  MotorboatAvatar,
  PaddleCraftAvatar,
  PersonalWatercraftAvatar,
  SailBoatAvatar,
} from '@deckee/deck-hand';

export const getStoredImage = (name, size = 40) => {
  const hash = imageFormatStringCodec.encode({
    resize: {
      width: size * 4,
      height: size * 4,
    },
  });

  return `/public/app-main/image/${name}--${hash}.jpg`;
};

export const getWatercraftImage = (watercraftType, size = 64) => {
  switch (watercraftType) {
    case 'paddle craft':
      return <PaddleCraftAvatar size={size} />;
    case 'personal watercraft':
      return <PersonalWatercraftAvatar size={size} />;
    case 'sailboat':
      return <SailBoatAvatar size={size} />;
    case 'motorboat':
    default:
      return <MotorboatAvatar size={size} />;
  }
};
